var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_547_9247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1124 28.8595V28.8691H18.1823V28.8547C18.159 28.8547 18.1357 28.8547 18.1124 28.8547V28.8595ZM16.8037 11.2463L16.8177 11.2607V10.9864C16.8177 11.0778 16.813 11.1645 16.8037 11.2463ZM16.8177 10.6544V10.8854C16.8223 10.8228 16.8317 10.7362 16.8456 10.6255L16.8177 10.6544ZM18.1543 10.6255C18.1637 10.7362 18.173 10.8228 18.1776 10.8854V10.6544L18.1543 10.6255Z",
    fill: "url(#paint0_linear_547_9247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7172 24.6152C29.5556 23.8404 30.2635 23.0319 30.8456 22.2668C33.4444 18.8356 35 14.3168 35 10.1829C35 6.04913 33.4118 3.54189 30.9574 3.54189C25.825 3.54189 20.7904 7.19447 18.4198 9.19641C18.5642 8.28687 18.7784 7.14153 19.0905 6.00101C19.8869 3.04141 20.9441 1.41002 22.0572 1.41002V0C19.5609 0 18.2056 3.61408 17.4977 6.69399C16.7944 3.61408 15.4345 0 12.9381 0V1.41002C14.0559 1.41002 15.1084 3.04141 15.9095 6.00101C16.2169 7.13672 16.4311 8.28206 16.5755 9.1916C14.2049 7.19447 9.16567 3.54189 4.03792 3.54189C1.5835 3.54189 0 6.14538 0 10.1829C0 14.2205 1.5509 18.8356 4.15436 22.2668C4.73653 23.0319 5.43979 23.8404 6.27811 24.6104C5.7658 25.2745 4.86693 26.4872 4.04258 27.8924C2.31005 30.8568 1.78842 33.1571 2.48703 34.7452C3.1344 36.2033 4.72721 36.9444 7.23287 36.9444C13.334 36.9444 16.2961 33.8405 17.5023 31.0012C18.7039 33.8405 21.666 36.9444 27.7625 36.9444C30.2681 36.9444 31.8656 36.2033 32.5083 34.7452C33.2116 33.1571 32.6853 30.8568 30.9528 27.8924C30.1284 26.4872 29.2342 25.2793 28.7172 24.6152ZM16.8177 10.6546L16.8456 10.6257C16.8317 10.7364 16.8224 10.823 16.8177 10.8855V10.6546ZM16.8037 11.2465C16.813 11.1647 16.8177 11.078 16.8177 10.9866V11.2609L16.8037 11.2465C16.7432 11.8336 16.501 12.3148 16.0679 12.7191C14.6194 14.0809 11.3407 14.2253 9.60346 14.1483C9.60346 12.4399 9.39854 8.02701 7.3819 5.48608C11.8623 6.83354 15.8397 10.3514 16.8037 11.2465ZM8.21557 24.4227C9.13772 23.3832 10.8516 21.7952 12.3653 21.6604C12.519 21.7663 12.682 21.8722 12.845 21.978C14.4471 22.9982 16.0353 23.6046 16.8177 23.8693V27.4497C14.7964 27.3727 13.0452 26.954 11.5363 26.338C11.5269 26.3332 11.5176 26.3284 11.513 26.3284L11.3965 26.2755C11.2102 26.1985 11.0333 26.1166 10.8563 26.0348C9.86893 25.5729 8.98869 25.0194 8.21557 24.4227ZM9.64072 15.5632C11.2475 15.6257 14.857 15.5632 16.8177 13.9077V22.3774C14.857 21.6508 10.181 19.5093 9.64072 15.5632ZM1.37858 10.669C1.36926 10.5054 1.3646 10.3418 1.3646 10.1829C1.3646 7.95482 1.96075 5.38502 3.60479 5.00485C3.60945 5.00004 3.61411 5.00485 3.61411 5.00485C4.61544 5.0241 5.43047 5.39465 6.1151 6.13094C7.99667 8.17138 8.22488 12.3437 8.2342 14.0328V14.0761H8.22488C4.54092 13.8018 2.01198 11.3475 1.37858 10.669ZM4.41517 20.2263C2.99468 17.9934 1.99335 15.3466 1.5835 12.7624C2.9155 13.8548 5.15103 15.2455 8.06188 15.4813C7.70326 16.8625 6.92083 19.0521 5.69128 19.8943C5.29075 20.1686 4.87159 20.2793 4.41517 20.2263ZM5.36061 21.569C5.73786 21.4727 6.10113 21.3091 6.45043 21.0685C7.55888 20.3081 8.31803 18.8933 8.81171 17.618C9.27279 18.6767 10.004 19.6633 10.9914 20.568C9.33333 21.2273 7.87558 22.7143 7.15835 23.5324C6.45509 22.8827 5.85895 22.2138 5.36061 21.569ZM3.73054 34.1581C3.24152 33.0561 3.7678 31.0974 5.20226 28.6383C5.98004 27.3101 6.84165 26.1455 7.33533 25.5055C8.21557 26.1888 9.2169 26.8241 10.3486 27.3486C9.58483 29.1051 7.17232 33.9945 3.78177 34.264C3.76314 34.2303 3.74451 34.1918 3.73054 34.1581ZM15.4857 31.8049C13.8463 34.2784 11.0705 35.5344 7.23287 35.5344C6.49235 35.5344 5.85895 35.4671 5.34198 35.3323C8.67199 34.0667 10.8423 29.673 11.5921 27.9309C12.9894 28.6768 15.3367 30.236 15.523 31.7471C15.509 31.7664 15.4997 31.7856 15.4857 31.8049ZM16.3426 30.1109C16.0632 29.6489 15.672 29.1821 15.1737 28.7249C15.6673 28.7875 16.1796 28.8308 16.7106 28.8501C16.6407 29.1917 16.5243 29.6249 16.3426 30.1109ZM16.8876 28.8693H16.8177V28.8597H16.8876V28.8693ZM27.837 23.5276C27.1151 22.7095 25.6574 21.2225 24.004 20.568C24.9914 19.6633 25.7226 18.6719 26.1836 17.6132C26.6773 18.8885 27.4365 20.3081 28.5496 21.0685C28.8942 21.3043 29.2575 21.4727 29.6347 21.5642C29.1364 22.209 28.5403 22.8827 27.837 23.5276ZM18.1823 22.3774V13.9125C20.1477 15.568 23.7478 15.6257 25.3546 15.5632C24.8144 19.4997 20.143 21.6412 18.1823 22.3774ZM30.5848 20.2263C30.1284 20.2793 29.7046 20.1686 29.3041 19.8943C28.0792 19.0521 27.2967 16.8625 26.9381 15.4813C29.8536 15.2504 32.0892 13.8548 33.4212 12.7624C33.0067 15.3466 32.0053 17.9934 30.5848 20.2263ZM31.3812 5.00485C31.3812 5.00485 31.3812 5.00004 31.3906 5.00485C33.0346 5.38502 33.6354 7.95482 33.6354 10.1829C33.6354 10.3418 33.6354 10.5006 33.6214 10.6642C32.9973 11.3379 30.4637 13.8018 26.7705 14.0761H26.7611V14.0328C26.7751 12.3437 26.9987 8.181 28.8802 6.13575C29.5649 5.39465 30.3799 5.0241 31.3812 5.00485ZM27.6181 5.48608C25.5968 8.02701 25.3919 12.4351 25.3919 14.1483C23.65 14.2253 20.3806 14.0809 18.9275 12.7191C18.499 12.3148 18.2522 11.8336 18.1963 11.2465L18.1823 11.2609V10.9866C18.1823 11.078 18.1823 11.1647 18.1963 11.2465C19.1603 10.3514 23.1331 6.83354 27.6181 5.48608ZM18.1823 10.6546V10.8855C18.173 10.823 18.1637 10.7364 18.1544 10.6257L18.1823 10.6546ZM18.1823 28.8693H18.1124V28.8597C18.1357 28.8597 18.159 28.8597 18.1823 28.8597V28.8741V28.8693ZM18.1823 23.8645C18.9694 23.6046 20.5529 22.9982 22.1504 21.978C22.3134 21.8722 22.4764 21.7663 22.6301 21.6604C24.1437 21.7903 25.8576 23.3832 26.7798 24.4227C26.002 25.0194 25.1264 25.5729 24.1391 26.0348C23.9388 26.1311 23.7292 26.2225 23.515 26.314L23.4824 26.3284C23.4824 26.3284 23.4731 26.3284 23.4591 26.338C21.9501 26.954 20.1989 27.3727 18.1823 27.4497V23.8645ZM18.6434 30.1302C18.4617 29.6345 18.35 29.1917 18.2801 28.8501C18.8157 28.8308 19.328 28.7875 19.8263 28.7249C19.3234 29.1869 18.9275 29.6585 18.6434 30.1302ZM27.7625 35.5344C23.1051 35.5344 20.7066 33.6432 19.4724 31.776C19.6307 30.2601 22.0013 28.6864 23.4079 27.9309C24.1577 29.673 26.3234 34.0618 29.6487 35.3323C29.1317 35.4671 28.4983 35.5344 27.7625 35.5344ZM31.2695 34.1581C31.2555 34.1918 31.2369 34.2303 31.2182 34.264C27.8277 33.9945 25.4152 29.1051 24.6514 27.3486C25.7831 26.8193 26.7844 26.1888 27.66 25.5055C28.1537 26.1455 29.02 27.3101 29.7931 28.6383C31.2322 31.0974 31.7538 33.0561 31.2695 34.1581Z",
    fill: "url(#paint1_linear_547_9247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8875 28.8599V28.8695H16.8176V28.8599H16.8875Z",
    fill: "url(#paint2_linear_547_9247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23417 14.0327V14.076H8.22485V14.0327H8.23417Z",
    fill: "url(#paint3_linear_547_9247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8177 10.9863V11.2606L16.8037 11.2462C16.813 11.1644 16.8177 11.0778 16.8177 10.9863Z",
    fill: "url(#paint4_linear_547_9247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8456 10.6255C16.8316 10.7362 16.8223 10.8228 16.8176 10.8854V10.6544L16.8456 10.6255Z",
    fill: "url(#paint5_linear_547_9247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3965 26.2753C11.2102 26.1983 11.0332 26.1165 10.8562 26.0347L11.3965 26.2753Z",
    fill: "url(#paint6_linear_547_9247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8176 10.6544V10.8854C16.8223 10.8228 16.8316 10.7362 16.8456 10.6255L16.8176 10.6544ZM18.1543 10.6255C18.1636 10.7362 18.1729 10.8228 18.1776 10.8854V10.6544L18.1543 10.6255ZM18.1822 10.9864V11.2607L18.1962 11.2463C18.1869 11.1645 18.1822 11.0778 18.1822 10.9864ZM16.8176 28.8595V28.8691H16.8875V28.8595H16.8176Z",
    fill: "url(#paint7_linear_547_9247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1822 28.8545V28.8689H18.1123V28.8593C18.1356 28.8593 18.1589 28.8593 18.1822 28.8593V28.8545Z",
    fill: "url(#paint8_linear_547_9247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1822 10.6544V10.8854C18.1729 10.8228 18.1636 10.7362 18.1543 10.6255L18.1822 10.6544Z",
    fill: "url(#paint9_linear_547_9247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1961 11.2462L18.1821 11.2606V10.9863C18.1821 11.0778 18.1821 11.1644 18.1961 11.2462Z",
    fill: "url(#paint10_linear_547_9247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7703 14.0327V14.076H26.761V14.0327H26.7703Z",
    fill: "url(#paint11_linear_547_9247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.139 26.0298C23.9387 26.1308 23.7291 26.2223 23.5149 26.3137L24.139 26.0298Z",
    fill: "url(#paint12_linear_547_9247)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_547_9247",
    x1: 16.8037,
    y1: 10.9959,
    x2: 19.4729,
    y2: 11.1942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7876E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201824,
    stopColor: "#5250E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401055,
    stopColor: "#957DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562457,
    stopColor: "#4D25CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77682,
    stopColor: "#5630CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89535,
    stopColor: "#401DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_547_9247",
    x1: -8.94369e-7,
    y1: 0.750142,
    x2: 36.4906,
    y2: 34.7345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7876E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201824,
    stopColor: "#5250E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401055,
    stopColor: "#957DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562457,
    stopColor: "#4D25CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77682,
    stopColor: "#5630CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89535,
    stopColor: "#401DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_547_9247",
    x1: 16.8176,
    y1: 28.8601,
    x2: 16.8202,
    y2: 28.8788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7876E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201824,
    stopColor: "#5250E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401055,
    stopColor: "#957DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562457,
    stopColor: "#4D25CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77682,
    stopColor: "#5630CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89535,
    stopColor: "#401DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_547_9247",
    x1: 8.22485,
    y1: 14.0336,
    x2: 8.24221,
    y2: 14.0373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7876E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201824,
    stopColor: "#5250E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401055,
    stopColor: "#957DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562457,
    stopColor: "#4D25CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77682,
    stopColor: "#5630CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89535,
    stopColor: "#401DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_547_9247",
    x1: 16.8037,
    y1: 10.9919,
    x2: 16.8308,
    y2: 10.9933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7876E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201824,
    stopColor: "#5250E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401055,
    stopColor: "#957DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562457,
    stopColor: "#4D25CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77682,
    stopColor: "#5630CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89535,
    stopColor: "#401DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_547_9247",
    x1: 16.8176,
    y1: 10.6308,
    x2: 16.8714,
    y2: 10.6365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7876E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201824,
    stopColor: "#5250E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401055,
    stopColor: "#957DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562457,
    stopColor: "#4D25CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77682,
    stopColor: "#5630CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89535,
    stopColor: "#401DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_547_9247",
    x1: 10.8562,
    y1: 26.0396,
    x2: 11.0353,
    y2: 26.4349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7876E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201824,
    stopColor: "#5250E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401055,
    stopColor: "#957DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562457,
    stopColor: "#4D25CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77682,
    stopColor: "#5630CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89535,
    stopColor: "#401DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_547_9247",
    x1: 16.8176,
    y1: 10.9959,
    x2: 19.4868,
    y2: 11.1942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7876E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201824,
    stopColor: "#5250E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401055,
    stopColor: "#957DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562457,
    stopColor: "#4D25CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77682,
    stopColor: "#5630CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89535,
    stopColor: "#401DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_547_9247",
    x1: 18.1123,
    y1: 28.8548,
    x2: 18.1181,
    y2: 28.8822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7876E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201824,
    stopColor: "#5250E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401055,
    stopColor: "#957DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562457,
    stopColor: "#4D25CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77682,
    stopColor: "#5630CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89535,
    stopColor: "#401DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_547_9247",
    x1: 18.1543,
    y1: 10.6308,
    x2: 18.2081,
    y2: 10.6365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7876E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201824,
    stopColor: "#5250E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401055,
    stopColor: "#957DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562457,
    stopColor: "#4D25CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77682,
    stopColor: "#5630CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89535,
    stopColor: "#401DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_547_9247",
    x1: 18.1821,
    y1: 10.9919,
    x2: 18.2093,
    y2: 10.9933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7876E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201824,
    stopColor: "#5250E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401055,
    stopColor: "#957DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562457,
    stopColor: "#4D25CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77682,
    stopColor: "#5630CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89535,
    stopColor: "#401DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_547_9247",
    x1: 26.761,
    y1: 14.0336,
    x2: 26.7783,
    y2: 14.0373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7876E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201824,
    stopColor: "#5250E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401055,
    stopColor: "#957DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562457,
    stopColor: "#4D25CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77682,
    stopColor: "#5630CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89535,
    stopColor: "#401DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_547_9247",
    x1: 23.5149,
    y1: 26.0356,
    x2: 23.7292,
    y2: 26.4987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7876E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201824,
    stopColor: "#5250E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401055,
    stopColor: "#957DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562457,
    stopColor: "#4D25CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77682,
    stopColor: "#5630CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89535,
    stopColor: "#401DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7876E6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_547_9247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 36.9444,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f10d8b66c9143ad3a1324b02e552c729.svg";
export { ForwardRef as ReactComponent };